module.exports = __webpack_public_path__ + "static/illustration-body-m-0890fafce845bdaf8604885ff6736bb8.svg";